module.exports = __webpack_public_path__ + "static/img/6.74658c08.png";